import {styled} from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`
  border: none;
   
  .ant-card-body {
    padding: 0 0;
  }

`;